<template>
	<a-dialog class="contact-send">
		<h1>{{ $t("contactSendTitle") }}</h1>
		<p>
			{{ $t("contactSend") }}
			<a :href="'mailto:' + email" class="contact-send__link">{{ email }}</a
			>.
			<br />
			{{ $t("contactSend2") }}
		</p>
		<a-button :to="{ name: 'home' }" class="contact-send__button">
			{{ $t("backButton") }}
		</a-button>
	</a-dialog>
</template>

<script>
import aDialog from "@/components/Dialog";
import aButton from "@/components/Button";
import survey from "@/survey";
import RouterGuards from "../mixins/RouterGuards";

export default {
	components: {
		aDialog,
		aButton,
	},
	mixins: [RouterGuards],

	data() {
		return {
			items: [this.$t("items[0]"), this.$t("items[1]")],
			email: survey.email,
		};
	},
	computed: {
		fullReportItems() {
			return [this.$t("item1"), this.$t("item2"), this.$t("item3")];
		},
	},
	i18n: {
		messages: {
			en: {
				contactSendTitle: "Check your email for the results!",
				contactSend: "We have sent your full report to ",
				contactSend2: "You should be able to view it any moment now.",
				fullReportsTitle: "The full report includes:",
				backButton: "Back to homepage",
			},
			nl: {
				contactSendTitle: "Open je e-mail om de resultaten te bekijken!",
				contactSend: "We hebben het volledige rapport verstuurd naar ",
				contactSend2: "Je ontvangt elk moment een email.",
				fullReportsTitle: "Het volledige rapport bevat:",
				backButton: "Terug naar de homepagina",
			},
		},
	},
	beforeRouteEnter(to, from, next) {
		if (!survey.answers) {
			next({ name: "survey" });
		}
		if (!survey.email) {
			next({ name: "contact" });
		} else {
			next();
		}
	},
};
</script>

<style lang="scss">
@import "@/styles/checkmark.scss";

.contact-send {
	max-width: 930px;
}

.contact-send__link {
	color: var(--primary-color);
	text-decoration: none;
	font-weight: 500;
}

.contact-send__link:hover {
	text-decoration: underline;
}

.contact-send__button {
	margin-top: 15px;
}

@media only screen and (max-width: 767px) {
	.contact-send {
		padding: 0 20px 50px;
	}

	.contact-send__button {
		width: 100%;
	}
}
</style>
